import { render, staticRenderFns } from "./wisdom_project_detail.vue?vue&type=template&id=d15b28a2&"
import script from "./wisdom_project_detail.vue?vue&type=script&lang=js&"
export * from "./wisdom_project_detail.vue?vue&type=script&lang=js&"
import style0 from "./wisdom_project_detail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports